export default __webpack_public_path__ + "static/Room-A-84ec72cd426a576686efa7bd36252cb4.jpg";